// extracted by mini-css-extract-plugin
export default {"wrap":"NewPost_wrap__cz3-K","new_post":"NewPost_new_post__CtQHn","new_edit":"NewPost_new_edit__41-93","nav":"NewPost_nav__J38Ly"};